import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy-notice-dialog',
  templateUrl: './privacy-notice-dialog.component.html',
  styleUrl: './privacy-notice-dialog.component.scss',
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
})
export class AppPrivacyNoticeDialogComponent {}
